'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDropdownContent = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _decisivUiUtils = require('decisiv-ui-utils');

var _styledComponentsReactiveGrid = require('styled-components-reactive-grid');

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ARROW_WIDTH = _constants2.default.ARROW_WIDTH;


var styles = function styles(_ref) {
  var theme = _ref.theme,
      zIndex = _ref.zIndex,
      hideContent = _ref.hideContent;
  return '\n    ' + theme.planes.sky1 + ';\n    background-color: ' + theme.colors.base.background + ';\n    border-radius: 0;\n    display: ' + (hideContent ? 'none' : 'flex') + ';\n    position: absolute;\n    z-index: ' + zIndex + ';\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    overflow: -moz-scrollbars-none;\n  ';
};

var getTopValue = function getTopValue(hasArrow) {
  return hasArrow ? 'calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ')' : '100%';
};

var modifierConfig = {
  bottom: function bottom(_ref2) {
    var arrow = _ref2.arrow;
    return '\n    top: ' + getTopValue(arrow) + ';\n  ';
  },

  bottomLeft: function bottomLeft(_ref3) {
    var theme = _ref3.theme,
        arrow = _ref3.arrow;
    return '\n    top: ' + getTopValue(arrow) + ';\n    border-top-left-radius: ' + theme.dimensions.borderRadius + ';\n    left: 0;\n  ';
  },

  bottomRight: function bottomRight(_ref4) {
    var theme = _ref4.theme,
        arrow = _ref4.arrow;
    return '\n    top: ' + getTopValue(arrow) + ';\n    border-top-right-radius: ' + theme.dimensions.borderRadius + ';\n    right: 0;\n  ';
  },

  fullWidth: function fullWidth() {
    return '\n    min-width: 100%;\n    left: 0;\n    right: 0;\n  ';
  }
};

var propTypes = {
  hideContent: _propTypes2.default.bool,
  zIndex: _propTypes2.default.number,
  arrow: _propTypes2.default.bool
};

var defaultProps = {
  hideContent: false,
  zIndex: 1,
  arrow: false
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      shadow: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    borderRadius: _propTypes2.default.string.isRequired
  })
};

var StyledDropdownContent = exports.StyledDropdownContent = (0, _decisivUiUtils.buildStyledComponent)('Dropdown__Content', _styledComponents2.default.div, styles, {
  defaultProps: defaultProps,
  modifierConfig: modifierConfig,
  propTypes: propTypes,
  themePropTypes: themePropTypes
});

function DropdownContent(props) {
  return _react2.default.createElement(
    StyledDropdownContent,
    props,
    _react2.default.createElement(
      _styledComponentsReactiveGrid.Container,
      { modifiers: ['padScale_0'] },
      props.children
    )
  );
}

DropdownContent.displayName = 'Dropdown__Content';

DropdownContent.propTypes = {
  children: _propTypes2.default.node.isRequired
};

exports.default = DropdownContent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/Dropdown/Content.js
// module id = 1646
// module chunks = 2